import React, { memo, useMemo } from 'react'
import { useLoggedInUser } from '../../../app/hooks/useLoggedInUser'
import SpinnerModalBlock from '../../../components/Spinner/SpinnerModalBlock'
import { useProductTabContext } from '../ProductTabContext'
import { IProductCategory } from '../types'
import { useProductCategory } from './hooks/useProductCategory'
import ProductCategoryForm from './ProductCategoryForm'

interface ProductCategoryModalProps {
  readonly productCategoryId: number
  readonly isDisabled?: boolean
}

const ProductCategoryModal: React.FC<ProductCategoryModalProps> = memo(({
  productCategoryId,
  isDisabled = false
}) => {
  const { customerId } = useProductTabContext()
  const { tenantId } = useLoggedInUser()

  const { productCategory, isLoading, isError } = useProductCategory({
    customerId,
    productCategoryId,
  })

  const defaultProductCategory: IProductCategory = useMemo(() => ({
    hsLocalTariffs: [],
    customerId,
    name: '',
  }), [customerId])

  if (isLoading) {
    return <SpinnerModalBlock />
  }

  if (isError) {
    return (
      <div>
        Error loading product category. Please try again.
      </div>
    )
  }

  return (
    <ProductCategoryForm
      productCategory={productCategory ?? defaultProductCategory}
      isDisabled={isDisabled}
    />
  )
})

ProductCategoryModal.displayName = 'ProductCategoryModal'

export default ProductCategoryModal
